import * as React from 'react'
const CheckIcon = () => (
  <div style={{ width: 24, height: 24 }}>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="M5.5 12.5l4 4 9-9"
        stroke="currentColor"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)

export default CheckIcon
